import { useEffect, useState } from 'react';
import './PlacesPage.scss';
import api, { baseURL } from '../../utils/api';
import { Loader } from 'semantic-ui-react';
import { useNavigate, useParams } from "react-router";
import Project from '../../structures/project';

function PlacesPage() {
    const [project, setProject] = useState<Project|null>(null)
    const { projectId } = useParams() as { projectId: string };
    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            let projects = await api.getProjects();
            const project = projects.filter(x=>x.id === projectId)[0];
            setProject(project);
        })()
    }, [projectId])
    if(!project) return <Loader active={true} size='big'/>
	return <div className='places-page'>
		{project.places.map((place) => <div 
					className='place-item' 
					onClick={() => navigate(`/places/${projectId}/${place.id}`)} 
					key={place.id}>
						<div><img alt={place.name} src={`${baseURL}/api/generatedImage/${place.imageId}`}/></div>
						<div>{place.name}</div>            
				</div>)}
	</div>;
}

export default PlacesPage;
